import type { BrandValidateError } from 'types/brand';

const isBrandValid = (errors: BrandValidateError) => Object.values(errors).every((k) => k === true);

export { isBrandValid };
